import { Outlet } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function PageLayout() {
  return (
    <div>
      <SiteHeader />
      <div className="flex-grow-1">
        <main>
          <Outlet />
        </main>
      </div>
      <SiteFooter />
    </div>
  );
}
